/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocflowDialogButton } from './docflowDialogButton';


export interface DocflowStandardDialogModel { 
    /**
     * Dialog message
     */
    message: string;
    yesMessage: DocflowDialogButton;
    noMessage: DocflowDialogButton;
    /**
     * Method id
     */
    methodId: number;
    /**
     * Document instance id
     */
    instanceId: number;
}

